module.exports = __webpack_public_path__ + "static/image1-91909a0cf76238589994a93d22bc1a84.png";